import React from "react";
import "./Heading.scss";

type Props = { children: string };

function Heading({ children }: Props) {
  return <div className="heading-container">{children}</div>;
}
export { Heading as default };
